export default "__VITE_ASSET__B_khX8a1__"